export default (url) => (url.indexOf(`http`) !== 0 ? `https://${url}` : url)
